// removed by extract-text-webpack-plugin
module.exports = {"forbidden":"forbidden___1jzVh","modalSwitch":"modalSwitch___29K8V"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FeatureAuthorisations/FeatureAuthorisations.module.scss
// module id = 2102
// module chunks = 0